import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../../constants';
import { TaskItemService } from '../../../services/task-item.service';
import ITaskItemDTO = ZoningAPI.ITaskItemDTO;

@Component({
    standalone: false,
    selector: 'app-paginated-process-task-items-list',
    templateUrl: './paginated-process-task-items-list.component.html',
    styleUrls: ['./paginated-process-task-items-list.component.scss']
})
export class PaginatedProcessTaskItemsListComponent implements OnInit, OnDestroy {
    @Input()
    processId: string;

    @Input()
    stateEnv: string;

    @Input()
    showPaginatorOnTop: boolean = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    taskItems: ITaskItemDTO[] = [];
    totalTaskItemsCount: number = 0;
    isLoading: boolean = false;

    DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    DEFAULT_PAGE_SIZE_OPTIONS = DEFAULT_PAGE_SIZE_OPTIONS;

    private destroy$ = new Subject<void>();

    constructor(private readonly taskItemService: TaskItemService) {}

    ngOnInit(): void {
        this.loadTaskItems(1, DEFAULT_PAGE_SIZE);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    loadTaskItems(page: number, limit: number): void {
        if (!this.processId || !this.stateEnv) {
            return;
        }

        this.isLoading = true;

        this.taskItemService
            .getTaskItems(this.stateEnv, this.processId, {
                page,
                limit,
                getCount: true
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                response => {
                    this.taskItems = response.taskItems;
                    this.totalTaskItemsCount = response.totalCount;
                    this.isLoading = false;
                },
                error => {
                    console.error('Error loading task items:', error);
                    this.taskItems = [];
                    this.totalTaskItemsCount = 0;
                    this.isLoading = false;
                }
            );
    }

    onPageChanged(event: PageEvent): void {
        this.loadTaskItems(event.pageIndex + 1, event.pageSize);
    }

    resetPagination(): void {
        if (!this.paginator) {
            return;
        }
        this.paginator.pageIndex = 0;
    }
}
